import { styled } from '@mui/material/styles';

export const Bold = styled('span')(() => ({
	fontWeight: '600',
}));
